import { Component } from '@angular/core';

@Component({
  selector: 'app-loader-overlay',
  imports: [],
  template: `<img src="images/kinomap-white.svg" alt="" /> `,
  styles: `
    @use '../../../styles/styles.scss' as *;

    :host {
      position: absolute;
      top: 0;
      left: 0;
      height: 100vh;
      width: 100vw;
      background: $neutral-900;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 30;
      opacity: 1;
      transition: opacity 500ms ease-out;
      img {
        height: 4rem;
        width: 4rem;
        animation: pulse 3s ease-in-out infinite;
      }
    }

    :host.leaving {
      opacity: 0;
    }
  `,
  host: {
    'animate.leave': 'leaving',
  },
})
export class LoaderOverlay {}
